<template>
  <main class="form-page__main form-page__main--registration-path">
    <div class="registration-path__content-wrapper">
      <header
        style="display: block"
        id="page-header--"
        class="page-header page-header-- page-header--simple"
      >
        <h1 class="page-header__title" v-t="'register.register_title'" />
        <div class="pp-preamble">
          <p class="pp-event__sponsor" v-if="event.sponsor">
            {{ event.sponsor }}
          </p>
          <h2 class="pp-event__title">{{ getTitle }}</h2>
        </div>
      </header>
      <a
        class="login-prompt"
        :href="loginUrl"
        v-t="'register.register_description'"
        v-if="!user.userLoggedIn"
      ></a>
      <section
        v-if="eventStatus.status === 'open'"
        class="form-page__form-wrapper form-page__form-wrapper--registration"
      >
        <registration-form
          :formSchema="getFormSchema()"
          v-if="getFormSchema()"
        />
      </section>
      <div v-else>
        <aside class="error-wrapper" role="alert">
          <mark class="error-item">
            <font-awesome-icon
              icon="exclamation-triangle"
              class="error-item_icon"
            />
            <div class="error-item__description">
              <p class="error-item__description" v-t="statusText" />
            </div>
          </mark>
        </aside>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import RegistrationForm from "@/components/form/RegistrationForm";

export default {
  name: "registration",
  components: {
    RegistrationForm,
  },
  watch: {
    "$i18n.locale": function () {
      this.languageSwitch();
    },
  },
  async created() {
    this.updateStage("registration-details");
    this.initCreated();
  },
  methods: {
    async languageSwitch() {
      await this.retrieveRegistrationSessions(this.$route.params.event);
      await this.retrieveUserDetails();

      let sessionToSubmit = this.event.sessionsFound.filter((item) => {
        return item.CRMEventID == this.performance.productId;
      });
      sessionToSubmit = sessionToSubmit[0];

      this.updateSessionSelected(sessionToSubmit);
    },
    async initCreated() {
      this.clearError();
      this.clearRegistrationData();
    },
    ...mapActions([
      "updateSessionSelected",
      "clearError",
      "updateStage",
      "updateUserLoggedIn",
      "retrieveUserDetails",
      "clearRegistrationData",
      "retrieveRegistrationSessions",
    ]),
    ...mapGetters(["getFormSchema"]),
  },
  computed: {
    statusText() {
      let status = this.eventStatus.status;
      if (status === 'full') {
        status = 'full_extended'
      }

      return `session.status.${status}`
    },
    eventStatus() {
      let status = _.get(this.event.sessionsStatus, this.performance.productId);

      return status;
    },
    loginUrl() {
      let backend = process.env.VUE_APP_WK_CRM_URL;

      return (
        backend +
        "/oauth/check?redirect=" +
        window.location.href +
        "&language=" +
        this.$i18n.locale
      );
    },
    getTitle() {
      return this.event.registrationEvent.title;
    },
    ...mapState(["event", "performance", "user"]),
  },
};
</script>